import store from './store'
import router from './router'

export default function() {
  const $router = router()
  return {
    router: $router,
    store: store
  }
}
